import actionCreatorFactory from "typescript-fsa";
import { FileDeleteRequestBody, FileDeleteResponse } from "../../core/api/requests/file/delete/types";
import { FileResultRequestBody, FileResultResponse } from "../../core/api/requests/file/result/types";
import { FileTemplateRequestBody, FileTemplateResponse } from "../../core/api/requests/file/templates/types";
import { FileUploadRequestBody, FileUploadResponse } from "../../core/api/requests/file/upload/types";
import { FileUserRequestBody, FileUserResponse } from "../../core/api/requests/file/users/types";
import { CommonAsyncType } from "../../core/types";
import { FileDownloadRequestBody, FileDownloadResponse } from "./../../core/api/requests/file/download/types";

const actionCreator = actionCreatorFactory("@@File");

export const fileActions = {
  getFileUploadTemplates: actionCreator.async<CommonAsyncType & FileTemplateRequestBody, FileTemplateResponse>("GET_FILE_UPLOAD_TEMPLATES"),
  getFileUploadUsers: actionCreator.async<CommonAsyncType & FileUserRequestBody, FileUserResponse>("GET_FILE_UPLOAD_USERS"),
  getFileUploadResults: actionCreator.async<CommonAsyncType & FileResultRequestBody, FileResultResponse>("GET_FILE_UPLOAD_RESULTS"),
  uploadFile: actionCreator.async<CommonAsyncType<FileUploadResponse> & FileUploadRequestBody, FileUploadResponse>("UPLOAD_FILE"),
  downloadFileUploadResult: actionCreator.async<CommonAsyncType<FileDownloadResponse> & FileDownloadRequestBody, {}>("DOWNLOAD_FILE_UPLOAD_RESULT"),
  deleteFileUploadResults: actionCreator.async<CommonAsyncType<FileDeleteResponse> & FileDeleteRequestBody, {}>("DELETE_FILE_UPLOAD_RESULTS"),
  resetToInitialState: actionCreator("RESET_TO_INITIAL_STATE"),
};
